/*
 * @Author: Teemo Ding
 * @Date: 2021-08-11 16:40:37
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-07 11:00:32
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDetails/CustomerPrivacy/index.tsx
 */

import { Button } from '@/src/components/Antd';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import {
  request_deleteCustomer,
  request_deleteSubscriber,
} from '@/src/request/customer/customerDetail';
import { getParameter } from '@/src/tools/helper';
import { message } from 'antd';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { i18nGet } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import RemovePopup from '../../Components/RemovePopup';
import css from '../css.module.less';

const permissions = () => {
  const erase_customer_data = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.erase_customer_data,
      }),
    ],
  });
  return {
    erase_customer_data,
  };
};
const CustomerPrivacy = ({
  setShowModal,
  setModalTitle,
  setModalContent,
  customerDatabaseUuid,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { erase_customer_data } = permissions();
  const history = useHistory();
  const params: any = useParams();
  const parameterType = getParameter('type');
  const { customerUuid } = params;
  const onDelete = (value) => {
    const req =
      parameterType == 'Subscriber'
        ? request_deleteSubscriber(customerUuid)
        : request_deleteCustomer(customerUuid);
    req.then(() => {
      message.success(getI18n('customerList.subscription.successfullyremoved'));
      history.push(`/customerDatabase/customerList/${customerDatabaseUuid}`);
    });
  };

  const deleteSubscriber = () => {
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>
        {parameterType == 'Subscriber'
          ? getI18n('customerList.customerPrivacy.removeSubscription')
          : getI18n('customerList.customerPrivacy.eraseCustomerData')}
      </ErrorModalTitle>,
    );
    setModalContent(
      <RemovePopup
        type={parameterType}
        onDelete={onDelete}
        onCancel={() => setShowModal(false)}
      />,
    );
  };

  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={`${css.informationContainer} ${css.wrapperContainer}`}
        title={
          parameterType == 'Subscriber'
            ? getI18n('customerList.customerPrivacy.subscriberPrivacy')
            : getI18n('customerList.customerPrivacy.customerPrivacy')
        }>
        <Button
          onClick={() => deleteSubscriber()}
          ghost
          danger
          disabled={!erase_customer_data}>
          {parameterType == 'Subscriber'
            ? getI18n('customerList.customerPrivacy.removeSubscription')
            : getI18n('customerList.customerPrivacy.eraseCustomerData')}
        </Button>
      </SectionWrapper>
    </div>
  );
};

export default CustomerPrivacy;
